<script setup>
import { clone } from 'lodash';
import { watch } from 'vue';
import { propsEditor } from './editores_mixins';
import IndicadorVariable from './IndicadorVariable.vue';

const props = defineProps({
  formulaTipo: { type: String, default: 'media' },
  ...propsEditor(),
});

const emits = defineEmits(['update:modelValue', 'eliminarVariableDisponible']);

// Si cambian las variables disponibles, directamente las usamos para el modelo
// porque eso es que han seleccionado nuevas
watch(
  props.variablesDisponibles,
  () => {
    const modelo = clone(props.modelValue);
    // Si las variables venían de una ponderación tendrán el campo "valor"
    // pero en las medias y sumas no se pueden enviar este campo, no se usa
    modelo.formula_variables = props.variablesDisponibles.map((variable) => (
      { ...variable, valor: null }
    ));

    emits('update:modelValue', modelo);
  },
  { deep: true, immediate: true },
);

</script>

<template>
  <div>
    <div class="subtitulo-seccion m-b">
      {{ $I18n.t('elementos') }}
    </div>
    <table class="table table-striped">
      <tbody>
        <tr
          v-for="variable in modelValue.formula_variables"
          :key="variable.id"
          class=""
        >
          <td class="col-min">
            <IndicadorVariable :variable="variable" />
          </td>
          <td class="text-bold">
            <label :for="variable.nombre_variable">
              {{ variable.label }}
            </label>
          </td>
          <td class="col-min">
            <div
              class="btn btn-white btn-sm"
              @click="$emit('eliminarVariableDisponible', variable)"
            >
              <i class="fa fa-times text-danger"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
